export default __webpack_public_path__ + "static/media/linkedInLogo.15a4be62.svg";